import { createContext, FC, ReactNode, useContext } from "react"

import { DEFlag, FRFlag, GBFlag, NLFlag, FlagProps } from "mantine-flagpack"

import en from "../../assets/i18n/en"

export type LanguageCode =
    | "en" // English
    | "de" // German
    | "nl" // Dutch
    | "fr" // French

export const languages: Record<LanguageCode, { label: string; Flag: FC<FlagProps> }> = {
    en: { label: "English", Flag: GBFlag },
    de: { label: "Deutsch", Flag: DEFlag },
    nl: { label: "Nederlands", Flag: NLFlag },
    fr: { label: "Français", Flag: FRFlag },
}

export type TranslationId = keyof typeof en

export type Translations = Record<TranslationId, string>

export type Locator = {
    (id: TranslationId): string
    (id: TranslationId, ...variables: (string | number)[]): string
    (id: TranslationId, ...variables: ReactNode[]): ReactNode[]
}

export type LanguageContextProps = {
    L: Locator
    code: LanguageCode
    setCode(code: LanguageCode): void
}

export const LanguageContext = createContext<LanguageContextProps>({
    L: ((id: TranslationId) => "") as Locator,
    code: "en",
    setCode: () => null,
})

export const useLanguage = () => useContext(LanguageContext)

export * from "./LanguageContext"
